import Select from 'react-select';
/**
 * WordPress dependencies
 */
const { useState } = wp.element;
const { useSelect } = wp.data;

const PostSelect = (props) => {
	const { postType } = props;
	const [searchKeyword, setSearchKeyword] = useState('');

	const { data, isRequesting } = useSelect(
		(select) => {
			const params = {
				per_page: 8,
				search: searchKeyword
			};

			return {
				data: select('core').getEntityRecords('postType', postType, params),
				isRequesting: select('core/data').isResolving('core', 'getEntityRecords', ['postType', postType, params])
			};
		},
		[postType, searchKeyword]
	);

	const options =
		data?.map((post) => ({
			label: `${post.title.raw} (ID: ${post.id})`, // Assuming the title is rendered
			value: post.id
		})) || [];

	return (
		<div>
			<Select
				classNamePrefix='conditional-blocks-select'
				className='conditional-blocks-select-container'
				isSearchable
				isLoading={isRequesting}
				options={options}
				onInputChange={(val) => setSearchKeyword(val)}
				{...props}
			/>
		</div>
	);
};

export default PostSelect;
